<template>
    <div>

        <div v-if="recurring.repeats_type === 'week'" class="flex flex-wrap items-start mb-4">
          <jet-checkbox wrapped label="Advanced Scheduling" name="advanced_scheduling" v-model="advanced_scheduling" class="w-48 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
          <tooltip position="left">
            <p class="mb-2 font-normal">When advance scheduling is unchecked global autoresponder will be scheduled for all week days.</p>
          </tooltip>
        </div>

        <div v-if="advanced_scheduling === true" class="p-4 md:px-8 md:pt-6 md:pb-8 bg-blue-100 sm:rounded">
            <label class="w-1/3 block text-gray-700 mt-2 mb-4">Send on these days only</label>
            <div class="flex justify-between">
                <jet-checkbox wrapped label="Sun" value="SUN" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Mon" value="MON" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Tue" value="TUE" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Wed" value="WED" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Thu" value="THU" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Fri" value="FRI" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
                <jet-checkbox wrapped label="Sat" value="SAT" name="repeats_on[]" v-model="recurring.repeats_on" class="w-12 flex items-center justify-around font-normal text-gray-700 text-base"></jet-checkbox>
            </div>
            <div class="flex mt-4">
              <div class="md:w-1/2 md:pl-2">
                <label class="w-full block text-gray-700">Start Time</label>
                <div class="flex -mx-2">
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="start_hour"
                    :options="hours"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="start_min"
                    :options="mins"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="start_period"
                    :options="['AM', 'PM']"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                </div>
              </div>
              <div class="md:w-1/2 md:pl-2">
                <label class="w-full block text-gray-700">End Time</label>
                <div class="flex -mx-2">
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="end_hour"
                    :options="hours"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="end_min"
                    :options="mins"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                  <multiselect
                    class="w-1/3 mx-2"
                    v-model="end_period"
                    :options="['AM', 'PM']"
                    :searchable="false"
                    select-label=""
                    deselect-label=""
                  ></multiselect>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            modelValue: Object
        },
        emits: ['update:modelValue'],
        data() {
            return {
                recurring: {
                    repeats_type: 'week',
                    repeats_on: [],
                    delay: null,
                },
                advanced_scheduling: true,
                hours: ['12', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11'],
                mins: [
                  '00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19',
                  '20','21','22','23','24','25','26','27','28','29','30','31','32','33','34','35','36','37','38','39',
                  '40','41','42','43','44','45','46','47','48','49','50','51','52','53','54','55','56','57','58','59'
                ],
                start_hour: '12',
                start_min: '00',
                start_period: 'AM',
                end_hour: '12',
                end_min: '00',
                end_period: 'AM',
            };
        },
        computed: {
            value() {
                return this.modelValue;
            },
            startTime : {
              get() {
                let hour = this.start_hour === "12" ? "00" : this.start_hour;

                if ( this.start_period === "PM" ) {
                  hour = parseInt(hour, 10) + 12;
                }

                // start time formatted as a value that Carbon will understand
                return `${hour}:${this.start_min}:00`;
              },
            },
            endTime : {
              get() {
                let hour = this.end_hour === "12" ? "00" : this.end_hour;

                if ( this.end_period === "PM" ) {
                  hour = parseInt(hour, 10) + 12;
                }

                // end time formatted as a value that Carbon will understand
                return `${hour}:${this.end_min}:00`;
              },
            },
            formData () {
                return {
                    delay: this.recurring.delay,
                    repeats_on: this.advanced_scheduling ? this.recurring.repeats_on : ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
                    start_time: this.advanced_scheduling ? this.startTime : "00:00:00",
                    end_time: this.advanced_scheduling ? this.endTime : "23:59:00",
                }
            },
        },
        methods: {
            initRecurringFields(){
                if (this.value) {
                    this.recurring.delay = this.value.delay
                    this.recurring.repeats_on = this.value.repeats_on
                  }
                if (this.value.repeats_on.length){
                  this.advanced_scheduling = true
                }
                this.$emit('update:modelValue', this.formData)
            },
          parseTime() {
            if (this.value.start_time) {
                let [hour1, min1, sec1] = this.value.start_time.split(':');
                hour1 = parseInt(hour1, 10);

                let period1 = 'AM';
                if (hour1 >= 12) {
                period1 = 'PM';
                if (hour1 > 12) {
                    hour1 -= 12;
                }
                }
                this.start_hour = hour1 > 9 ? `${hour1}` : `0${hour1}`;
                this.start_min = min1;
                this.start_period = period1;
            } else {
                this.start_hour = '12';
                this.start_min = '00';
                this.start_period = 'AM';
            }
            
            if (this.value.end_time) {
              let [hour2, min2, sec2] = this.value.end_time.split(':');
              hour2 = parseInt(hour2, 10);

              let period2 = 'AM';
              if (hour2 >= 12) {
                period2 = 'PM';
                if (hour2 > 12) {
                  hour2 -= 12;
                }
              }
              this.end_hour = hour2 > 9 ? `${hour2}` : `0${hour2}`;
              this.end_min = min2;
              this.end_period = period2;

            } else {
                this.end_hour = '12';
                this.end_min = '00';
                this.end_period = 'AM';
            }

          }
        },
        watch: {
            formData: {
                handler() {
                    this.$emit('update:modelValue', this.formData);
                },
                deep: true,
            }
        },
        mounted() {
            this.initRecurringFields();
            this.parseTime();
        },
    }

</script>